export default class Part {
    static render(width, mods) {
        const WIDTH = width * SIZE.pxInMm;
        const HEIGHT = SIZE.baseHeight // TODO  
        let x = (WIDTH - 43.5 * mods) / 2 - (mods - 1) * 10.5
        let y = (HEIGHT - 74.6) / 2;
        return `<image href="${PARTS['switch_' + mods]}" x="${x}" y="${y}" />`
    }
}
